import { rem } from 'polished'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import { Swiper, useSwiper } from 'swiper/react'
import { Image, IMAGE_LAYOUT } from 'components/Image'
import { Box } from 'components/Layout'
import { ASPECT_RATIO } from 'components/UploadImage/constants'
import { BORDER_WIDTH, COLOR_INTENT, RADIUS } from 'Theme'

const WRAPPER_PADDING = rem(4)

const IMAGE_SIZE = rem(48)

const Wrapper = styled(Box)`
  padding: ${WRAPPER_PADDING};
  border: ${BORDER_WIDTH.PX_2} solid
    ${({ isActive }) => (isActive ? COLOR_INTENT.BRAND : 'transparent')};
  border-radius: ${RADIUS.PX_6};
  cursor: pointer;
`

export const ProductThumbnailImage = ({
  url,
  alt,
  index,
  isActive,
  swiper,
}) => {
  const thumbsSwiper = useSwiper()
  return (
    <Wrapper
      isActive={isActive}
      onClick={() => {
        // this prevents unresponsiveness of thumbnails - https://github.com/sudolabs-io/the-expert/issues/5156
        swiper.slideTo(index)
        thumbsSwiper.update()
      }}
    >
      <Image
        aspectRatio={ASPECT_RATIO.PRODUCTS}
        alt={alt || `Navigation product image #${index}`}
        layout={IMAGE_LAYOUT.RESPONSIVE}
        objectFit="cover"
        src={url}
        sizes={IMAGE_SIZE}
      />
    </Wrapper>
  )
}

ProductThumbnailImage.propTypes = {
  url: PropTypes.string.isRequired,
  alt: PropTypes.string,
  index: PropTypes.number.isRequired,
  isActive: PropTypes.bool,
  swiper: PropTypes.instanceOf(Swiper).isRequired,
}
